{
  "auth": {
    "invalidCredentials": "The email or password is incorrect. If you changed your password, use the new one.",
    "emailNotConfirmed": "Check your inbox and click the confirmation link before signing in.",
    "passwordsDontMatch": "Passwords do not match. Please try again.",
    "passwordTooShort": "Password must be at least 6 characters.",
    "invalidEmail": "The email address format is invalid.",
    "disposableEmail": "Temporary emails are not allowed. Please use a real email.",
    "recaptchaFailed": "Security verification failed. Please try again.",
    "emailAlreadyInUse": "This email is already registered.",
    "registerSuccess": "Account created! Check your email to confirm it.",
    "loginSuccess": "Signed in successfully!",
    "emailNotConfirmedTitle": "Email not confirmed",
    "invalidCredentialsTitle": "Invalid credentials",
    "loggingIn": "Signing in...",
    "creatingAccount": "Creating account...",
    "fillCredentials": "Enter your email and password."
  },
  "events": {
    "foodRain": "Food Rain",
    "meteorShower": "Meteor Shower",
    "poisonZone": "Poison Zone",
    "gravityWell": "Gravity Well",
    "warning": "{{name}} in {{seconds}}s",
    "nextEvent": "NEXT EVENT",
    "nextDanger": "NEXT DANGER"
  },
  "hud": {
    "mass": "Mass",
    "kills": "Kills",
    "deaths": "Deaths",
    "players": "Players",
    "bots": "Bots",
    "ranking": "Ranking",
    "top5": "TOP 5",
    "streak": "Streak",
    "profile": "PROFILE",
    "help": "HELP",
    "hunts": "Hunts:",
    "fleesFrom": "Flees from:",
    "you": "YOU",
    "none": "NONE",
    "spectatorBadge": "SPECTATOR MODE",
    "observingArena": "Observing the arena",
    "observingTarget": "Observing {{alias}} ({{mass}} mass)",
    "playNow": "PLAY NOW"
  },
  "combat": {
    "combo": "{{count}}x Combo",
    "comboText": "⚡ COMBO x{{count}}!",
    "massBonus": "+{{count}} MASS",
    "killstreak": "Killstreak: {{count}}",
    "dominating": "DOMINATING",
    "unstoppable": "UNSTOPPABLE",
    "bloodthirsty": "BLOODTHIRSTY",
    "alchemyGod": "ALCHEMY GOD",
    "shutdown": "SHUTDOWN",
    "shutdownTitle": "🎯 BOUNTY HUNTER!",
    "shutdownDesc": "{{killer}} stopped {{victim}} (+{{bounty}})",
    "respawningIn": "Respawning in {{seconds}}s..."
  },
  "powerups": {
    "speed": "Speed",
    "doubleMass": "Double Mass",
    "shield": "Shield",
    "invulnerability": "Invulnerability",
    "freeze": "Freeze",
    "speedTitle": "Super Speed (20s)",
    "speedBonus": "+50% starting mass (150)",
    "doubleMassTitle": "Super Absorption (25s)",
    "doubleMassBonus": "+50% starting mass (150)",
    "tripleShieldTitle": "Triple Shield (3 hits)",
    "tripleShieldBonus": "+50% starting mass (150)",
    "invulnerabilityTitle": "Total Immunity (12s)",
    "invulnerabilityBonus": "+50% starting mass (150)",
    "healingTitle": "Instant Regeneration",
    "healingBonus": "+150% starting mass (250)"
  },
  "elements": {
    "fire": "Fire",
    "water": "Water",
    "plant": "Plant",
    "electric": "Electric",
    "earth": "Earth"
  },
  "skins": {
    "default": "Default",
    "ring": "Ring",
    "dotted": "Dotted",
    "metallic": "Metallic",
    "eyes": "Eyes",
    "smile": "Smile"
  },
  "tutorial": {
    "welcome": "Welcome to Alchem.io",
    "step1": "Move with mouse or touch",
    "step2": "Eat orbs to grow",
    "step3": "Use counters to punish bigger players",
    "step4": "Survive and climb the ranking",
    "stepLabel": "STEP {{current}}/{{total}}",
    "identity": "You are your element. Hunt and flee based on counters.",
    "movement": "Move your mouse or joystick to navigate the arena.",
    "growth": "Absorb energy orbs to grow ({{count}}/3).",
    "danger": "Watch out! A counter rival is near. Keep distance.",
    "skip": "Skip tutorial"
  },
  "modals": {
    "play": "Play",
    "spectate": "Spectate",
    "revive": "Revive",
    "profile": "Profile",
    "help": "Help",
    "close": "Close",
    "enterArena": "ENTER ARENA",
    "enterAsSpectator": "👁️ ENTER AS SPECTATOR",
    "chooseIdentity": "Choose your identity",
    "chooseSkin": "Choose your skin:",
    "aliasPlaceholder": "Your alias (max 12)",
    "showTutorial": "Show tutorial on first launch",
    "anonHint": "If left empty you will play as AnonXXX",
    "youHaveBeenDevoured": "YOU HAVE BEEN DEVOURED",
    "reviveFree": "Revive now (free)",
    "reviveFreeSub": "Normal respawn with no wait or ads",
    "respawnAction": "Respawn →",
    "staySpectator": "Stay as spectator",
    "staySpectatorSub": "Watch the match live and join whenever you want",
    "watchAction": "Spectate →",
    "watchAdBonus": "OR RETURN STRONGER WITH A BONUS",
    "watchAdTag": "🎁 WATCH AD (~15s)",
    "adCooldown": "⏳ Ad rewards available in {{timer}}",
    "confirmChangeAlias": "Are you sure you want to change your alias? You will be prompted for a new one.",
    "confirmResetProgress": "Are you sure you want to reset your progress? All your local stats will be lost.",
    "profileTitle": "ALCHEMIST PROFILE",
    "changeAlias": "Change alias",
    "resetProgress": "Reset progress",
    "profileCloseHint": "Press [P] or [ESC] to close"
  },
  "misc": {
    "loading": "Loading...",
    "connecting": "Connecting...",
    "disconnected": "Disconnected",
    "connectionError": "Connection error. Please refresh the page.",
    "spawnGreeting": "You are {{element}}",
    "spawnHint": "Move mouse or press a key to start"
  },
  "quests": {
    "title": "QUESTS & ACHIEVEMENTS",
    "dailyTab": "Daily Quests",
    "achievementsTab": "Alchemical Achievements",
    "resetIn": "Resets in:",
    "claim": "Claim",
    "claimed": "Claimed",
    "completed": "Completed!",
    "astralChanneling": "Astral Channeling",
    "watchAd": "Watch Ad (+2 🔮, +50 💎)",
    "adsRemaining": "{{remaining}}/3 left today",
    "noAdsLeft": "Daily limit reached (3/3)",
    "adSuccess": "Channeling successful! You received 2 🔮 and 50 💎",
    "adError": "Could not complete ad. Please try again later.",
    "rewardClaimed": "Reward claimed!",
    "rewardClaimedDesc": "+{{crystals}} 💎 and +{{orbs}} 🔮",
    "loginStreak": "Streak: {{days}} days",
    "kill_players": "Eliminate 3 players",
    "eat_orbs": "Consume 400 nutrients",
    "drain_mass_counter": "Drain 1,500 mass with counters",
    "reach_mass": "Reach 2,500 mass",
    "survive_time": "Survive 4 minutes in one life",
    "collect_powerups": "Collect 3 power-ups",
    "desc_kill_players": "Devour 3 rivals in the alchemical arena.",
    "desc_eat_orbs": "Absorb nutrient mass orbs scattered across the arena.",
    "desc_drain_mass_counter": "Strike rivals by exploiting elemental counters.",
    "desc_reach_mass": "Grow and stay alive until you reach 2,500 mass.",
    "desc_survive_time": "Stay alive continuously for 240 seconds.",
    "desc_collect_powerups": "Find and collect power-up spheres in the arena."
  },
  "achievements": {
    "login_streak_5": "Log in 5 days in a row",
    "reach_titan_8k": "Reach 8,000 mass",
    "kill_with_all_elements": "Score 1 kill with each element",
    "shutdown_bounty": "Neutralize 3 players on a killstreak",
    "desc_login_streak_5": "Prove your consistency by logging into Alchem.io for 5 consecutive days.",
    "desc_reach_titan_8k": "Become a titan by reaching 8,000 mass.",
    "desc_kill_with_all_elements": "Master all 5 elements with at least one kill with each.",
    "desc_shutdown_bounty": "End the killstreak of at least 3 rivals on a rampage (Shutdown)."
  }
}

